import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20abstract%20Korean%20manhwa%20art%20style%20comic%20background%2C%20warm%20vibrant%20coral%20red%20and%20golden%20amber%20color%20palette%2C%20dynamic%20geometric%20shapes%2C%20comic%20style%20halftone%20dots%20and%20speed%20lines%2C%20modern%20digital%20illustration%2C%20artistic%20atmospheric%20soft%20gradients%2C%20clean%20minimal%20composition&width=1600&height=900&seq=hanman-hero-bg&orientation=landscape"
        alt="韩漫之家 - 韩国漫画免费阅读平台"
        title="韩漫之家 - 韩国漫画免费阅读"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight">
          韩国漫画<span className="text-primary-400">免费阅读</span>平台
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-background-200 max-w-2xl mx-auto leading-relaxed">
          韩漫之家汇集海量优质<strong>韩国漫画</strong>资源，涵盖<strong>韩漫在线</strong>和<strong>韩漫大全</strong>，
          每日更新热门连载，随时随地畅享流畅的阅读体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link
            to="/category/all"
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
          >
            开始阅读 <i className="ri-arrow-right-line ml-1 w-4 h-4 inline-flex items-center justify-center align-middle"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 rounded-full border border-background-300/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
          >
            了解更多
          </Link>
        </div>
        <div className="flex items-center justify-center gap-6 mt-10 text-xs text-background-300">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400 w-3.5 h-3.5 flex items-center justify-center"></i>
            正版授权
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400 w-3.5 h-3.5 flex items-center justify-center"></i>
            每日更新
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400 w-3.5 h-3.5 flex items-center justify-center"></i>
            完全免费
          </span>
        </div>
      </div>
    </section>
  );
}